import React, { useState } from 'react';
import { Modal } from 'antd';
import './style.scss';
import classNames from 'classnames';
import getFormatMessage from '../../locales/get-format-message';
import ReactDOM from 'react-dom';
import warnImage from '../../assets/images/warn-yellow.png';
import { CancelButton, CommonButtonGroup, SubmitButton } from '../button/main';
interface IProps {
  readonly onClose?: () => void;
  readonly width?: string;
  readonly onOk?: () => Promise<boolean>;
  readonly oKText?: string;
  readonly cancelText?: string;
  readonly title?: React.ReactNode | string;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly footer?: React.ReactNode;
  readonly loading?: boolean;
  readonly okButtonProps?: { [key: string]: any };
  readonly maskClosable?: boolean;
  readonly danger?: boolean;
}
export const ModalWrap = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const onOk = async () => {
    if (props.onOk) {
      if (loading) {
        return;
      }
      setLoading(true);
      await props.onOk();
      setLoading(false);
    }
  };
  const renderFooter = () => {
    return (
      <div className="gc-modal-footer">
        <CommonButtonGroup className="col-right" gap={8}>
          {props.cancelText ? (
            <CancelButton onClick={props.onClose}>
              {props.cancelText || getFormatMessage('cancel')}
            </CancelButton>
          ) : null}
          {props.oKText ? (
            <SubmitButton
              danger={props.danger}
              loading={loading}
              onClick={onOk}
              {...props.okButtonProps}
            >
              {props.oKText || getFormatMessage('save')}
            </SubmitButton>
          ) : null}
        </CommonButtonGroup>
      </div>
    );
  };
  const classnames = classNames('modal-wrap', props.className);
  return (
    <Modal
      className={classnames}
      title={props.title}
      width={props.width || 600}
      open={true}
      onCancel={props.onClose}
      maskClosable={props.maskClosable || false}
      getContainer={false}
      centered={true}
      footer={props.footer || renderFooter()}
    >
      {props.children}
    </Modal>
  );
};

const showModal = (props: IProps, icon?: React.ReactNode) => {
  const id = `common-modal-${Math.random()}`;
  const container = document.createElement('div');
  container.id = id;
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.render(<></>, container);
    document.body.removeChild(container);
  };

  const onClose = async () => {
    await props.onClose?.();
    destroy();
  };

  const onOk = async () => {
    try {
      const res = await props.onOk?.();
      if ((props.onOk && res === true) || !props.onOk) {
        destroy();
      }
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const modalProps: IProps = {
    ...props,
    title: (
      <>
        {icon}
        <span>{props.title}</span>
      </>
    ),
    onOk,
    onClose,
  };

  ReactDOM.render(<ModalWrap {...modalProps} />, container);

  return { destroy };
};

ModalWrap.show = (props: IProps) => {
  return showModal(props);
};

ModalWrap.warn = (props: IProps) => {
  return showModal(
    props,
    <img
      src={warnImage}
      alt="Warning"
      style={{ marginRight: '10px', marginTop: '-2px' }}
    />
  );
};
